<template>
  <div :class="`
  info-card-wrapper
  ${borderLeft ? 'border-left' : '' }
  ${borderRight ? 'border-right' : '' }`"

  :style="`
  border-left-color: ${borderLeftColor};
  border-right-color: ${borderRightColor};  
  `"  
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SGPInforCardComponent",
  props: {
    borderLeft: {
      type: Boolean,
      required: false,
      default: true
    },

    borderLeftColor: {
      type: String,
      required: false,
      default: "##e3262e"
    },

    borderRight: {
      type: Boolean,
      required: false,
      default: false
    },

    borderRightColor: {
      type: String,
      required: false,
      default: "##e3262e"
    },
  }
}
</script>

<style scoped>
  .info-card-wrapper {
    background: #fff;
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    box-shadow: 0px 8px 8px -3px rgba(0,0,0,0.05);
  }

  .border-right {
    border-right: solid 8px #e3262e;
  }

  .border-left {
    border-left: solid 8px #e3262e;
  }
</style>